import { ContentBlock } from '../types'

export function hasContent(
  contentBlock?: ContentBlock | null
): contentBlock is ContentBlock {
  return (
    !!contentBlock &&
    Array.isArray(contentBlock.content) &&
    contentBlock.content.length > 0
  )
}
